import request from '../../utils/request'
import config from '../../../config/config'
const baseURL = config.baseUrl

//  信息新增
export function shopStockAdd (data) {
  return request({
    url: baseURL + 'shopStock/add',
    method: 'post',
    data: data
  })
}
//  信息查询
export function shopStockList (data) {
  return request({
    url: baseURL + 'shopStock/list',
    method: 'post',
    data: data
  })
}
//  信息删除
export function shopStockDelete (data) {
  return request({
    url: baseURL + 'shopStock/delete',
    method: 'post',
    data: data
  })
}
//  信息修改
export function shopStockUpdate (data) {
  return request({
    url: baseURL + 'shopStock/update',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/shopStock/index.js